import {
  Toast
} from 'mint-ui'
import { objToFormData, getShareUrl } from '@/utils/utils'
import {
  APPID
} from '@/data/config.js'
import {
  getOwnList,
  getjoinList,
  getDefault,
  getJoindetail,
  getOwnerDetail,
  specClassify,
  showSpecs,
  getKeyword,
  getSpecDetail,
  createPro,
  sendEmail,
  ownerEmail,
  updatetime,
  refundpic,
  getClothes,
  makephoto_v2,
  uploadPic,
  addteampeople,
  getCollectPay,
  createCollectOrder,
  getLogin,
  getQrcode
} from '@/data/api'
// 注意：每个actions函数超过一个参数用对象作为一个参数传

// 汇总相当于每个调用接口调用之前处理的东西
function ruleFn (fn, loadingTxt = '') {
  return async function (...arg) {
    const { commit } = arg.shift()
    try {
      loadingTxt && commit('setLoadingTxt', loadingTxt) // loading开启
      // await needOpenid(!state.platformInfo.openid) // 是否需要获取openid
      const b = arg[0] ? fn.bind(null, arg[0]) : fn.bind(null)
      const res = await b()
      loadingTxt && commit('setLoadingTxt', '') // loading关闭
      return res.data
    } catch (e) {
      loadingTxt && commit('setLoadingTxt', '') // loading关闭
      let message = ''
      message = typeof e === 'object' ? e.success ? '服务器异常' : e.message : e
      console.log(message)
      Toast({
        message,
        position: 'bottom',
        duration: 4000,
        className: 'zidx9999'
      })
      return Promise.reject(message)
    }
  }
}

function getOwnListA (...args) {
  const actionsObj = args.shift()
  const { state } = actionsObj
  const formData = new FormData()
  formData.append('app_id', APPID)
  formData.append('user_id', state.openid)
  return ruleFn(getOwnList, '数据加载中')(actionsObj, formData)
}

function getjoinListA (...args) {
  const actionsObj = args.shift()
  const { state } = actionsObj
  const formData = new FormData()
  formData.append('user_id', state.openid)
  return ruleFn(getjoinList, '数据加载中')(actionsObj, formData)
}

function getDefaultA (...args) {
  const { commit } = args.shift()
  getDefault().then(res => {
    console.log('res:::', res)
    const { data: { default_price, beauty_parameter, default_color } } = res
    commit('setDefault_price', default_price)
    commit('setBeautyDefault', beauty_parameter)
    const arr = default_color.map(item => {
      return {
        ...item,
        s_color: item.start_color.toString(16).padStart(6, 0),
        e_color: item.enc_color.toString(16).padStart(6, 0)
      }
    })
    commit('setDefaultColor', arr)
  })
}

function getJoindetailA (...args) {
  const actionsObj = args.shift()
  const { state } = actionsObj
  const no = args.shift()
  const formData = new FormData()
  formData.append('user_id', state.openid)
  formData.append('project_no', no)
  return ruleFn(getJoindetail, '数据加载中')(actionsObj, formData)
}

function getOwnerDetailA (...args) {
  const actionsObj = args.shift()
  const no = args.shift()
  const formData = new FormData()
  formData.append('project_no', no)
  return ruleFn(getOwnerDetail, '数据加载中')(actionsObj, formData)
}

function specClassifyA (...args) {
  const actionsObj = args.shift()
  return ruleFn(specClassify, '规格加载中')(actionsObj)
}

function showSpecsL (...args) {
  const actionsObj = args.shift()
  const param = args.shift()
  return ruleFn(showSpecs, '加载数据中')(actionsObj, param)
}

function showSpecsA (...args) {
  const actionsObj = args.shift()
  const param = args.shift()
  return ruleFn(showSpecs)(actionsObj, param)
}

function getKeywordL (...args) {
  const actionsObj = args.shift()
  const param = args.shift()
  return ruleFn(getKeyword, '搜索中')(actionsObj, param)
}

function getKeywordA (...args) {
  const actionsObj = args.shift()
  const param = args.shift()
  return ruleFn(getKeyword)(actionsObj, param)
}

function getSpecDetailA (...args) {
  const actionsObj = args.shift()
  const id = args.shift()
  return ruleFn(getSpecDetail, '数据加载中')(actionsObj, id)
}

function createProA (...args) {
  const actionsObj = args.shift()
  const { state } = actionsObj
  const data = {
    app_id: APPID,
    user_id: state.openid,
    ...state.teaminfo
  }
  return ruleFn(createPro, '创建中')(actionsObj, data)
}

function updatetimeA (...args) {
  const actionsObj = args.shift()
  const data = objToFormData(args.shift())
  return ruleFn(updatetime, '修改时间中')(actionsObj, data)
}

function makephoto_v2A (...args) {
  const actionsObj = args.shift()
  const { state } = actionsObj
  const obj = args.shift()
  const {
    spec_id,
    algo_fileuuid_origin,
    width_px,
    height_px,
    project_no
  } = state.makePhotoInfo
  const data = {
    ...project_no && { project_no },
    ...spec_id && { spec_id },
    ...algo_fileuuid_origin && { algo_fileuuid_origin },
    ...!spec_id && {
      width_px,
      height_px
    },
    ...obj
  }
  console.log('data:::', data)
  const formData = objToFormData(data)
  return ruleFn(makephoto_v2, '图片制作中')(actionsObj, formData)
}

function addteampeopleA (...args) {
  const actionsObj = args.shift()
  const { state } = actionsObj
  const project_no = args.shift()
  const data = {
    user_id: state.openid,
    project_no
  }
  return ruleFn(addteampeople, '数据加载中')(actionsObj, data)
}

function collectPayA (...args) {
  const actionsObj = args.shift()
  const clothes_path = args.shift()
  const { state: { makePhotoInfo, openid } } = actionsObj
  const {
    project_no,
    ori_file_name,
    algo_fileuuid,
    information
  } = makePhotoInfo
  const fee = clothes_path ? 1 : 0
  const data = {
    project_no,
    app_id: APPID,
    user_id: openid,
    ori_file_name,
    final_pic_name: algo_fileuuid,
    information,
    fee
  }
  return ruleFn(createCollectOrder, '创建订单中')(actionsObj, data)
}

function getLoginA (...args) {
  const actionsObj = args.shift()
  const code = args.shift()
  const data = {
    app_id: APPID,
    code
  }
  return ruleFn(getLogin, '用户登录中')(actionsObj, data).then(res => {
    console.log('登陆成功的openid:::', res.openid)
    const { commit } = actionsObj
    commit('setLoginState', 2)
    commit('setOpenid', res.openid)
    return res
  })
}

function getQrcodeA (...args) {
  const actionsObj = args.shift()
  const project_no = args.shift()
  const url = getShareUrl(project_no)
  const formData = new FormData()
  formData.append('url_param', url)
  formData.append('project_no', project_no)
  return ruleFn(getQrcode, '创建二维码')(actionsObj, formData)
}

export default {
  getOwnListA,
  getjoinListA,
  getDefaultA,
  getJoindetailA,
  getOwnerDetailA,
  specClassifyA,
  showSpecsL,
  showSpecsA,
  getKeywordL,
  getKeywordA,
  getSpecDetailA,
  createProA,
  sendEmailA: ruleFn(sendEmail, '邮箱发送中'),
  ownerEmailA: ruleFn(ownerEmail, '邮箱发送中'),
  updatetimeA,
  refundpicA: ruleFn(refundpic, '照片打回中'),
  getClothesA: ruleFn(getClothes, '数据获取中'),
  makephoto_v2A,
  uploadPicA: ruleFn(uploadPic, '上传图片中'),
  addteampeopleA,
  getCollectPayA: ruleFn(getCollectPay, '创建订单中'),
  collectPayA,
  getLoginA,
  getQrcodeA
}
